import { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import Header from "../../header/Header";
import { SpinnerCircle } from "../../../atoms/spinner/Spinner";
import Footer from "../../footer/Footer";
import { useNavigate } from "react-router-dom";
import { getSolicitudPDF } from "../../../services/DatoPersonalService";
import "../descargarBorradorActos/descargarBorradorActos.scss";

const DescargarBorradorActos = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [solicitud, setSolicitud] = useState();
  useEffect(() => {
    getSolicitudPDF(params?.id, location?.state?.tipoActo).then((data) => {
       setLoading(true);
      if (!data.toString().startsWith("Error:")) {
        var reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = function () {
          var base64data = reader.result;
          
          setSolicitud(base64data);
        
        };
      }
    });
  }, [params?.id, location?.state?.tipoActo]);
  return (
    <>
      <Header></Header>
      <div className="container d-flex flex-column card mt-5" id="inicio" role="main" data-landmark-index="4">
        {loading ? (
          <>
            <div className="my-auto">
              <div className="container-login fondo">
                <div className="tituloSolicitud">
                  <div className="d-flex align-items-center flex-column">
                    {/*<Titulo
                      titulo={"Acto S1 Variación de datos personales"}
                      tipo={"tituloPagina subTituloPagina"}
                    />*/}
                    {/* <p className="text-third-1">{datos.estado}</p> */}
                    <h2 className="tituloPagina tituloDesc noBg fs-3 fs-md-0">{location?.state?.tipoActo === "s1" ? "Acto S1 Variación de datos personales" : location?.state?.tipoActo === "z9" ? "Acto Z9 Reconocimiento de Nivel de Carrera" : ""}</h2>
                  </div>
                  <div className="datosPersonalesCarrera d-flex flex-column m-2">
                    <div>
                      <div className="d-flex justify-content-between">
                        {/*<Titulo
                          clases={"subSubTituloSolicitud p-2 fw-bold"}
                          tipo={"tituloCard noBg"}
                          titulo={"4. Descargar"}
                        ></Titulo>*/}
                        <h3 className="tituloPagina subtituloDesc noBg fs-3">4. Descargar</h3>
                      </div>
                      <div className="separador"></div>
                    </div>

                    <div className="formulario">
                      <>
                        <div className="m-2"></div>
                        <div className="m-3 card scroll-list container-list-border">
                          <div className="gridPresentar">
                            
                            <div className="iframePresentar pt-3">
                              <object
                                data={solicitud}
                                type="application/pdf"
                                height="500"
                                width="100%"
                                aria-label="PDF del borrador"
                                className="rounded"
                              />
                            </div>
                          </div>
                        </div>
                      </>
                      <div className="gridBotones mb-2">
                        <button
                          id="volver"
                          className="btnRed rounded btnCancelarDocumentacion"
                          type="button"
                          onClick={() => {
                            if (location?.state?.tipoActo === "s1") {
                              navigate("/variacionDatosPersonales")
                            } else if (location?.state?.tipoActo === "z9") {
                              navigate("/reconNivelCarrera")
                            }
                          }}
                        >
                          <i className="fa-solid fa-rotate-left"></i> Volver
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="error rojo fs-4 pt-2 d-flex align-items-center flex-column my-auto">
              <SpinnerCircle></SpinnerCircle>
            </div>
          </>
        )}
      </div>
      <Footer></Footer>
    </>
  );
};
export default DescargarBorradorActos;
